class ExcelHelper {
    excelStyle = {
        row: {
            height: 30,
        },
        titleAlignment: {
            vertical: 'middle',
            horizontal: 'left',
        },
        titleFont: {
            color: {argb: '00404040'},
            size: 14,
            bold: true,
        },
        titleBorder: {
            top: {style: 'thin', color: {argb: '00dddddd'}},
            left: {style: 'thin', color: {argb: '00dddddd'}},
            right: {style: 'thin', color: {argb: '00dddddd'}},
            bottom: {style: 'thin', color: {argb: '00dddddd'}},
        },
        headerFill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '00f0f0f0'},
            bgColor: {argb: '00f0f0f0'}
        },
        headerFont: {
            color: {argb: '00404040'},
            size: 12,
            bold: true,
        },
        headerBorder: {
            top: {style: 'thin', color: {argb: '00dddddd'}},
            left: {style: 'thin', color: {argb: '00dddddd'}},
            right: {style: 'thin', color: {argb: '00dddddd'}},
            bottom: {style: 'thin', color: {argb: '00dddddd'}},
        },
        headerAlignment: {
            vertical: "middle",
            horizontal: "center",
        },
        valueFill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'ffffffff'},
            bgColor: {argb: 'ffffffff'}
        },
        valueFont: {
            color: {argb: '00404040'},
            size: 12,
            bold: true,
        },
        cell: {
            border: {
                top: {style: 'thin', color: {argb: '00dddddd'}},
                left: {style: 'thin', color: {argb: '00dddddd'}},
                right: {style: 'thin', color: {argb: '00dddddd'}},
                bottom: {style: 'thin', color: {argb: '00dddddd'}},
            },
            alignment: {
                middle: {
                    vertical: "middle",
                    horizontal: "center",
                }
            },
            text: {
                alignment: {
                    default: {
                        vertical: "top",
                        horizontal: "left",
                        wrapText: true,
                    },
                },
            },
        },
        cellFillColorsByRow: [
            {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'FFFFFFFF'},
                bgColor:{argb:'FFFFFFFF'}
            },
            {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'FFF5F5F5'},
                bgColor:{argb:'FFF5F5F5'},
            },
        ],
        header: {
            alignment: {
                center: { horizontal: 'center', vertical: 'middle' },
            },
            font: {
                default: { bold: true, color: { argb: '00000000', }},
            },
            fill: {
                default: { type: 'pattern', pattern: 'solid', fgColor:{argb:'00eeeeee'}, bgColor:{argb:'00eeeeee'}},
            },
            border: {
                default: {
                    top: {style:'thin', color: { argb: '00dddddd' }},
                    left: {style:'thin', color: { argb: '00dddddd' }},
                    right: {style:'thin', color: { argb: '00dddddd' }},
                    bottom: {style:'thin', color: { argb: '00dddddd' }},
                },
            },
            height: 30,
        },
        layout: {

        },
        format: {
            number: "###,###,###,###",
        }
    }

    rowColorIndex = 0

    getRowColor() {
        return this.excelStyle.cellFillColorsByRow[this.rowColorIndex];
    }

    increaseRowColor() {
        this.rowColorIndex = ++this.rowColorIndex % 2;
    }
}

export default ExcelHelper;
